import { render, staticRenderFns } from "./DistributionRecords.vue?vue&type=template&id=ac94462e&scoped=true"
import script from "./DistributionRecords.vue?vue&type=script&lang=js"
export * from "./DistributionRecords.vue?vue&type=script&lang=js"
import style0 from "./DistributionRecords.vue?vue&type=style&index=0&id=ac94462e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac94462e",
  null
  
)

export default component.exports